export const locale = {
    'RETRANSFER' : {
      'TITLE' : 'Order transfer',
      'MESSAGE' : 'The order has already been transferred, a retransmission will cancel all previous ones. Continue?',
      'CONFIRM' : 'Transfer',
      'DECLINE' : 'Cancel',
    },
  };
  